/*
 * amondz Cart Interactions (v1.4)
 *
 * v1.4 변경 (Shopify Markets 다중 통화 대응):
 * - currencyFormatter / formatMoney 제거
 *   - JPY 하드코딩이라 EUR 등 다른 통화에서 ¥로 잘못 표시되는 버그
 * - sticky 합계는 Liquid가 그린 cart.total_price | money_with_currency 그대로 유지
 *   - Markets 클라이언트 컨버터가 알아서 환산
 * - data-final-price 기반 선택 합산 로직 제거
 *   - data-final-price는 shop currency(JPY) cents라 다중 통화 환산 불가
 *   - sticky 합계는 "카트 전체" 기준으로 고정 (명세서와 동일 기준)
 * - 체크박스 선택/해제는 결제 시 미체크 상품 제거에만 영향 (UX 그대로)
 *
 * 이전 변경 이력:
 * - v1.3: BOGOS hijack 방어 코드 제거 (앱 삭제됨)
 * - v1.2.5: BFCache 복원 시 스피너 무한 회전 수정
 * - v1.2.4: 결제 버튼 자체 스피너 주입 (.az-checkout-spinner)
 * - v1.2.3: 선택 0개 시 명세서 영역 숨김
 * - v1.1: localStorage 제거, default 전체 선택, confirm 모달 제거
 *
 * 책임:
 * - 체크박스 (전체선택 / 개별선택 동기화)
 * - 선택 삭제
 * - 수량 변경 (AJAX /cart/change.js)
 * - 개별 삭제
 * - 쿠폰 적용 / 해제
 * - sticky 푸터: 선택 개수 갱신, 체크아웃 버튼 disabled 상태
 *   (합계는 Liquid가 카트 전체 기준으로 그린 값 유지)
 * - 결제 진행 (미체크 상품은 카트에서 제거 후 /checkout)
 */

(function() {
  'use strict';

  var LOG_PREFIX = '[az-cart]';
  function log() {
    try { console.log.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch(e){}
  }

  var root = document.querySelector('[data-az-cart]');
  if (!root) return;

  var stickyForm = document.querySelector('[data-az-sticky-footer]');
  var stickyCount = document.querySelector('[data-az-sticky-count]');
  var stickyHint = document.querySelector('[data-az-sticky-hint]');
  var checkoutBtn = document.querySelector('[data-az-checkout]');
  // 주의: stickyTotal은 더 이상 JS가 갱신하지 않음 (Markets 환산 위해 Liquid 출력 유지)

  var selectAllInput = root.querySelector('[data-az-select-all]');
  var selectedCountEl = root.querySelector('[data-az-selected-count]');
  var deleteSelectedBtn = root.querySelector('[data-az-delete-selected]');

  // ============================================================
  // 상수
  // ============================================================
  var CHECKOUT_LABEL = '購入手続きへ';
  var CHECKOUT_LOADING_TEXT = '処理中…';
  var CHECKOUT_LOADING_HTML = '<span class="az-checkout-spinner" aria-hidden="true"></span>' + CHECKOUT_LOADING_TEXT;

  // 포인트 동기화 상태 (아래 "포인트 적용 감지" 섹션에서 사용)
  // pointReloading: 우리가 navigate/reload를 시작했음 → 그동안 포인트 동기화 억제
  var pointPolling = false;
  var pointReloading = false;
  var pointBaselineSig = null;
  var pointSeenPointCodes = {};  // 로드 시점에 이미 있던 VIP-POINT 코드(새 실패 코드만 감지하기 위함)
  var pointBaselineCoupons = [];  // 로드 시점에 적용 중이던 쿠폰 코드(포인트가 밀어냈는지 감지용)
  var POINT_COUPON_ATTEMPT_KEY = 'az_coupon_attempt';  // 마지막으로 시도한 쿠폰 코드(리로드 후 적용여부 확인용)
  var POINT_COUPON_KNOCKED_KEY = 'az_coupon_knocked';  // 포인트 적용으로 해제된 쿠폰 코드(리로드 후 안내용)

  function getCurrentSelected() {
    return [].slice.call(root.querySelectorAll('[data-az-select-item]:checked'))
      .map(function(input) { return input.getAttribute('data-key'); });
  }

  // ============================================================
  // BFCache 복원 시 스피너 원복
  // ============================================================
  if (checkoutBtn) {
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) {
        log('pageshow from bfcache, reset checkout button');
        checkoutBtn.textContent = CHECKOUT_LABEL;
        refreshSummary();
      }
    });
  }

  // ============================================================
  // refreshSummary
  // - 선택 개수 표시
  // - 체크아웃 버튼 disabled 상태
  // - 명세서 숨김 토글
  // - 전체선택 체크박스 상태 동기화
  // ※ sticky 합계는 갱신하지 않음 (Liquid가 그린 cart.total_price 유지)
  // ============================================================
  function refreshSummary() {
    var selected = getCurrentSelected();

    if (selectedCountEl) selectedCountEl.textContent = selected.length;
    if (stickyCount) stickyCount.textContent = selected.length;

    if (checkoutBtn) {
      var disabled = selected.length === 0;
      checkoutBtn.disabled = disabled;
      checkoutBtn.setAttribute('aria-disabled', String(disabled));
    }
    if (stickyHint) {
      stickyHint.hidden = selected.length > 0;
    }

    // 선택 0개일 때 명세서 숨김
    if (selected.length === 0) {
      root.setAttribute('data-az-cart-empty-selection', '');
    } else {
      root.removeAttribute('data-az-cart-empty-selection');
    }

    if (selectAllInput) {
      var totalItems = root.querySelectorAll('[data-az-select-item]').length;
      if (selected.length === 0) {
        selectAllInput.checked = false;
        selectAllInput.indeterminate = false;
      } else if (selected.length === totalItems) {
        selectAllInput.checked = true;
        selectAllInput.indeterminate = false;
      } else {
        selectAllInput.checked = false;
        selectAllInput.indeterminate = true;
      }
    }
  }

  // ============================================================
  // 이벤트: 체크박스
  // ============================================================
  root.addEventListener('change', function(e) {
    if (e.target.matches('[data-az-select-item]')) {
      refreshSummary();
    }
  });

  if (selectAllInput) {
    selectAllInput.addEventListener('change', function() {
      var checked = selectAllInput.checked;
      [].slice.call(root.querySelectorAll('[data-az-select-item]')).forEach(function(input) {
        input.checked = checked;
      });
      refreshSummary();
    });
  }

  // ============================================================
  // 수량 변경 / 개별 삭제 (AJAX)
  // ============================================================

  function changeLineQuantity(key, quantity) {
    log('change qty', key, quantity);
    var item = root.querySelector('[data-az-item][data-key="' + key + '"]');
    if (item) item.classList.add('is-updating');

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('change failed: ' + res.status);
      return res.json();
    })
    .then(function() {
      pointReloading = true;
      window.location.reload();
    })
    .catch(function(err) {
      log('change err', err);
      if (item) item.classList.remove('is-updating');
      alert('数量の変更に失敗しました');
    });
  }

  root.addEventListener('click', function(e) {
    var upBtn = e.target.closest('[data-az-qty-up]');
    if (upBtn) {
      var key = upBtn.getAttribute('data-key');
      var valEl = upBtn.parentElement.querySelector('[data-az-qty-value]');
      var cur = parseInt(valEl.textContent, 10) || 0;
      changeLineQuantity(key, cur + 1);
      return;
    }

    var downBtn = e.target.closest('[data-az-qty-down]');
    if (downBtn) {
      if (downBtn.disabled) return;
      var key2 = downBtn.getAttribute('data-key');
      var valEl2 = downBtn.parentElement.querySelector('[data-az-qty-value]');
      var cur2 = parseInt(valEl2.textContent, 10) || 0;
      if (cur2 <= 1) return;
      changeLineQuantity(key2, cur2 - 1);
      return;
    }

    var delBtn = e.target.closest('[data-az-delete]');
    if (delBtn) {
      var delKey = delBtn.getAttribute('data-key');
      if (!confirm('この商品をカートから削除しますか？')) return;
      changeLineQuantity(delKey, 0);
      return;
    }
  });

  // ============================================================
  // 선택 삭제
  // ============================================================

  if (deleteSelectedBtn) {
    deleteSelectedBtn.addEventListener('click', function() {
      var selected = getCurrentSelected();
      if (selected.length === 0) {
        alert('削除する商品を選択してください');
        return;
      }
      if (!confirm('選択した' + selected.length + '点の商品を削除しますか？')) return;

      var updates = {};
      selected.forEach(function(key) { updates[key] = 0; });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('update failed');
        return res.json();
      })
      .then(function() { pointReloading = true; window.location.reload(); })
      .catch(function(err) {
        log('delete-selected err', err);
        alert('削除に失敗しました');
      });
    });
  }

  // ============================================================
  // 쿠폰
  // ============================================================

  var couponForm = document.querySelector('[data-az-coupon-form]');
  var couponInput = document.querySelector('[data-az-coupon-input]');
  var couponError = document.querySelector('[data-az-coupon-error]');
  // 적용/해제 진행 중 연타 방지. 해제는 GET+POST 비동기 구간이 있어 연타 시
  // clear/재적용 체인이 경합해 쿠폰이 유실될 수 있다. 내비게이션하지 않고 끝나는
  // 분기에서만 false로 되돌린다(내비게이션하면 페이지가 갈리므로 불필요).
  var couponBusy = false;

  function applyDiscount(code) {
    var trimmed = (code || '').trim();
    if (!trimmed) return;
    if (couponBusy) return;  // 해제/적용 진행 중 → 무시(경합 방지)
    couponBusy = true;
    pointReloading = true;  // 곧 /discount로 이동 → 포인트 동기화 억제
    var returnTo = window.location.pathname;

    // 시도한 쿠폰을 기억(코드+시각) → 리로드 후 적용 여부 확인해 안내(pointCheckCouponAttempt).
    try { sessionStorage.setItem(POINT_COUPON_ATTEMPT_KEY, JSON.stringify({ c: trimmed, t: Date.now() })); } catch (e) {}

    // /discount/코드 단일 방문 = Shopify가 기존 결합 가능 코드(다른 쿠폰·VIP 포인트)에 자동 merge.
    // 콤마 다중코드(/discount/A,B)는 이 스토어에서 통째로 무효 처리돼 둘 다 미적용됨 → 반드시 단일로 넘긴다.
    // (이전엔 clear 후 활성코드+새코드를 콤마로 재적용했는데, 그게 제품 할인 병용 실패의 직접 원인이었음.
    //  단일 적용은 순차 검증 완료: /discount/A → /discount/B 시 A·B 둘 다 유지됨.)
    window.location.href = '/discount/' + encodeURIComponent(trimmed) + '?redirect=' + encodeURIComponent(returnTo);
  }

  if (couponForm) {
    couponForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (couponError) couponError.hidden = true;
      var code = couponInput ? couponInput.value : '';
      if (!code.trim()) {
        if (couponError) {
          couponError.textContent = 'コードを入力してください';
          couponError.hidden = false;
        }
        return;
      }
      applyDiscount(code);
    });
  }

  // 특정 쿠폰 하나만 해제 — 전체 비운 뒤 나머지 코드만 순차 재적용(다중 쿠폰 중 하나만 제거).
  // 단 포인트(VIP-POINT)가 있으면 전체 clear 없이 특정 쿠폰만 뺄 방법이 없고
  // (포인트는 URL 재적용 불가), 전부 날리면 포인트까지 사라지므로 그 경우엔 파괴 없이 안내만 한다.
  function removeDiscountCode(codeToRemove) {
    var target = (codeToRemove || '').toLowerCase();
    if (!target) return;  // 코드 식별 불가 → 아무것도 안 함(실수로 전체 clear 방지)
    if (couponBusy) return;  // 진행 중 연타 → 무시(clear/재적용 체인 경합 방지)
    couponBusy = true;
    pointReloading = true;  // 곧 이동/reload → 포인트 동기화 억제
    var returnTo = window.location.pathname;
    pointFetchCart().then(function(cart) {
      var applied = pointGatherAppliedCodes(cart);
      if (applied.some(pointIsPointCode)) {
        // 포인트 적용 중 → 개별 해제 불가. 포인트·다른 쿠폰 보존 위해 파괴 없이 안내만.
        var perr = document.querySelector('[data-az-coupon-error]');
        if (perr) {
          perr.textContent = 'ポイント利用中はクーポンを個別に解除できません。先にポイントの利用を取り消してください。';
          perr.hidden = false;
        }
        pointReloading = false;  // 이동/리로드 안 함 → 포인트 동기화 재개
        couponBusy = false;
        return;
      }
      var keep = applied.filter(function(c) { return c.toLowerCase() !== target; });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).then(function() {
        // keep이 비면 buildSequentialDiscountUrl은 returnTo만 반환 → 전부 비워진 채 리로드.
        window.location.href = buildSequentialDiscountUrl(keep, returnTo);
      }).catch(function() { window.location.reload(); });
    }).catch(function() {
      // 카트 조회 실패 → 포인트/다른 쿠폰 유무를 모르는 상태. 파괴적 폴백(전체 clear) 대신
      // 아무것도 바꾸지 않고 재시도 안내만(포인트 보호 원칙과 일관).
      var perr = document.querySelector('[data-az-coupon-error]');
      if (perr) {
        perr.textContent = 'クーポンを解除できませんでした。通信状態をご確認のうえ、もう一度お試しください。';
        perr.hidden = false;
      }
      pointReloading = false;
      couponBusy = false;
    });
  }

  document.addEventListener('click', function(e) {
    var toggleBtn = e.target.closest('[data-az-coupon-toggle]');
    if (toggleBtn && !toggleBtn.disabled) {
      var code = toggleBtn.getAttribute('data-code');
      var isApplied = toggleBtn.getAttribute('data-applied') === 'true';
      if (isApplied) {
        removeDiscountCode(code);
      } else {
        applyDiscount(code);
      }
      return;
    }

    var removeBtn = e.target.closest('[data-az-coupon-remove]');
    if (removeBtn) {
      e.preventDefault();
      removeDiscountCode(removeBtn.getAttribute('data-code'));
    }
  });

  // ============================================================
  // 포인트 적용 감지 → 명세서 갱신 (VIP use-point-form 대응)
  // - VIP 포인트 폼은 AJAX로 할인코드(VIP-POINT-*)를 카트에 적용하지만
  //   페이지를 리로드하지 않아, 서버 렌더된 금액 명세서가 stale 상태로 남음.
  //   카트 할인 변동을 감지해 reload로 갱신한다.
  // - 트리거: fetch/XHR 인터셉트(렌더 방식·shadow DOM 무관) + 포인트 폼 클릭(보조).
  // - 수량/삭제/쿠폰/결제 등 우리 액션은 자체 navigate/reload 하므로
  //   pointReloading 플래그로 그동안 포인트 동기화를 억제(이중 네비게이션 방지).
  // ============================================================

  var POINT_POLL_INTERVAL = 500;   // ms
  var POINT_POLL_MAX = 20;         // 최대 ≈10s (앱 프록시 지연 대비)
  var POINT_RELOAD_KEY = 'az_point_reloads';
  // 카트 변동 의심 URL (자체 /cart.js GET은 별도 제외)
  // /apps/(앱 프록시)는 카트 무관 앱 요청까지 잡아 불필요한 폴링을 유발하므로 제외.
  // VIP 포인트 적용은 트리거 B(포인트 폼 click/change/Enter)가 잡는다.
  var POINT_MUTATING = /\/(cart\/(add|update|change)|discount)(\.js|\/|\?|$)/i;

  function pointCartSig(cart) {
    // total_price + total_discount → 통화/라인레벨 무관, 적용·변경·해제 양방향 감지
    return cart.total_price + '|' + cart.total_discount;
  }

  function pointFetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res) { return res.json(); });
  }

  function pointIsMutatingUrl(url) {
    return !!url && POINT_MUTATING.test(url) && !/\/cart\.js(\?|$)/.test(url);
  }

  // 무한 리로드 방지: 5초 내 3회 이상 리로드면 중단(루프 의심).
  // 정상 연속 조작(적용→해제→재적용)은 사이클당 수 초라 통상 걸리지 않음.
  function pointReloadGuardOk() {
    try {
      var now = Date.now();
      var raw = sessionStorage.getItem(POINT_RELOAD_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      arr = arr.filter(function(t) { return now - t < 5000; });
      if (arr.length >= 3) return false;
      arr.push(now);
      sessionStorage.setItem(POINT_RELOAD_KEY, JSON.stringify(arr));
      return true;
    } catch (e) { return true; }
  }

  function pointDoReload() {
    if (pointReloading) return;
    if (!pointReloadGuardOk()) { log('point reload suppressed (loop guard)'); return; }
    pointReloading = true;
    log('point discount changed -> reload');
    window.location.reload();
  }

  // 새로 생긴 "적용 실패" 포인트 코드(VIP-POINT-*, applicable:false, 로드 시점엔 없던 것) 탐색
  function pointFindNewFailedCode(cart) {
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      var d = codes[i];
      if (d && d.code && pointIsPointCode(d.code) && d.applicable === false &&
          !pointSeenPointCodes[d.code.toLowerCase()]) {
        return d.code;
      }
    }
    return null;
  }

  // 포인트 적용 실패 안내를 포인트 폼 영역에 표시
  function pointShowApplyError(msg) {
    var wrap = root.querySelector('.az-vip-block--point-form');
    if (!wrap) return;
    var container = wrap.closest('.az-discount-item') || wrap.parentNode;
    if (!container) return;
    var el = container.querySelector('[data-az-point-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'az-discount-item__notice az-point-error';
      el.setAttribute('data-az-point-error', '');
      el.style.color = '#c0392b';
      container.appendChild(el);
    }
    el.textContent = msg;
    el.hidden = false;
  }

  // 포인트 적용으로 기존(로드 시점) 쿠폰이 밀려났으면 → 리로드 후 안내하도록 기록
  function pointFlagKnockedCoupon(cart) {
    var nowActive = pointGatherAppliedCodes(cart).map(function(c) { return c.toLowerCase(); });
    if (!nowActive.some(pointIsPointCode)) return;  // 포인트가 적용된 경우만(포인트가 이긴 상황)
    for (var i = 0; i < pointBaselineCoupons.length; i++) {
      if (nowActive.indexOf(pointBaselineCoupons[i].toLowerCase()) === -1) {  // 있던 쿠폰이 사라짐
        try { sessionStorage.setItem(POINT_COUPON_KNOCKED_KEY, pointBaselineCoupons[i]); } catch (e) {}
        return;
      }
    }
  }

  // 포인트가 쿠폰을 밀어낸 경우 안내(리로드 후). 다른 안내가 이미 떠 있으면 건너뜀.
  function pointCheckKnockedCoupon() {
    var knocked = null;
    try { knocked = sessionStorage.getItem(POINT_COUPON_KNOCKED_KEY); } catch (e) {}
    if (!knocked) return;
    try { sessionStorage.removeItem(POINT_COUPON_KNOCKED_KEY); } catch (e) {}
    var couponErr = document.querySelector('[data-az-coupon-error]');
    if (!couponErr || !couponErr.hidden) return;  // 요소 없거나 이미 다른 안내 표시중 → 건너뜀
    couponErr.textContent = 'クーポン「' + knocked + '」はポイントと併用できないため解除されました。ポイントを取り消すと、クーポンをご利用いただけます。';
    couponErr.hidden = false;
  }

  function pointStartPoll() {
    if (pointPolling || pointReloading || pointBaselineSig === null) return;
    pointPolling = true;
    var tries = 0;
    (function tick() {
      tries++;
      pointFetchCart().then(function(cart) {
        if (pointCartSig(cart) !== pointBaselineSig) {
          pointPolling = false;
          pointFlagKnockedCoupon(cart);  // 포인트가 기존 쿠폰을 밀어냈으면 리로드 후 안내하도록 기록
          pointDoReload();  // 할인 변동(포인트/쿠폰 적용·해제) → 명세서 갱신
          return;
        }
        // 변동 없음 → 새로 실패한 포인트 코드가 생겼으면(결합 불가 등으로 적용 거부) 안내
        var failed = pointFindNewFailedCode(cart);
        if (failed) {
          pointPolling = false;
          pointSeenPointCodes[failed.toLowerCase()] = true;  // 재표시 방지
          pointShowApplyError('ポイントを適用できませんでした。適用中のクーポン等との併用条件をご確認ください。');
          return;
        }
        if (tries >= POINT_POLL_MAX) { pointPolling = false; return; }  // 진짜 무변동 → 조용히 종료
        setTimeout(tick, POINT_POLL_INTERVAL);
      }).catch(function() { pointPolling = false; });
    })();
  }

  // ── 적용된 할인코드 수집 / VIP 포인트 코드 식별 ──
  function pointGatherAppliedCodes(cart) {
    var codes = [];
    (cart.discount_codes || []).forEach(function(d) {
      if (d && d.applicable && d.code && codes.indexOf(d.code) === -1) codes.push(d.code);
    });
    (cart.cart_level_discount_applications || []).forEach(function(a) {
      if (a && a.type === 'discount_code' && a.title && codes.indexOf(a.title) === -1) codes.push(a.title);
    });
    // 제품 할인(amount off products)은 위 두 소스에 안 잡히고 아이템별 line-level에만 있음.
    // 여기서 누락하면 재적용(keep) 시 기존 제품 쿠폰이 빠져 유실됨 → "하나만 적용" 증상.
    // 단 자동/스크립트 할인은 코드가 없어 /discount/로 재적용 불가하므로 discount_code 타입만 수집.
    (cart.items || []).forEach(function(item) {
      (item.line_level_discount_allocations || []).forEach(function(al) {
        var app = al && al.discount_application;
        if (app && app.type === 'discount_code' && app.title && codes.indexOf(app.title) === -1) {
          codes.push(app.title);
        }
      });
    });
    return codes;
  }

  // 특정 코드가 카트에 어떤 형태로든 적용됐는지 판정(대소문자 무시).
  // 3소스 확인: ① discount_codes(주문 할인 등) ② cart_level_discount_applications
  // ③ 아이템별 line_level_discount_allocations(제품 할인은 여기에만 잡힘).
  // (필드명은 /cart.js JSON 기준. cart_level_* / line_level_* 는 Liquid의 cart.discount_applications와 대응)
  function pointCouponIsApplied(cart, code) {
    if (!cart || !code) return false;
    var target = code.toLowerCase();
    var hit = (cart.discount_codes || []).some(function(d) {
      return d && d.applicable && d.code && d.code.toLowerCase() === target;
    });
    if (hit) return true;
    hit = (cart.cart_level_discount_applications || []).some(function(a) {
      return a && a.type === 'discount_code' && a.title && a.title.toLowerCase() === target;
    });
    if (hit) return true;
    return (cart.items || []).some(function(item) {
      return (item.line_level_discount_allocations || []).some(function(al) {
        var app = al && al.discount_application;
        return app && app.type === 'discount_code' && app.title &&
          app.title.toLowerCase() === target;
      });
    });
  }

  function pointIsPointCode(code) {
    return /VIP-?POINT/i.test(code || '');
  }

  // 여러 코드를 순차 단일 적용하는 /discount/ 리다이렉트 체인 URL 생성.
  // 콤마(/discount/A,B)는 이 스토어에서 통째 무효라, A 적용 후 redirect로 B 적용을 이어붙인다.
  // codes[0]이 가장 바깥(먼저 방문) → 순서대로 적용되고 마지막에 finalPath로 이동.
  function buildSequentialDiscountUrl(codes, finalPath) {
    var url = finalPath;
    for (var i = codes.length - 1; i >= 0; i--) {
      url = '/discount/' + encodeURIComponent(codes[i]) + '?redirect=' + encodeURIComponent(url);
    }
    return url;
  }

  // 포인트 사용 취소 — VIP-POINT 코드만 제거하고 쿠폰 등 나머지는 보존한다.
  // (Shopify엔 코드 단건 제거 URL이 없어, 전체 비운 뒤 남길 코드만 재적용)
  function removePointDiscount() {
    if (couponBusy) return;  // 쿠폰 적용/해제 진행 중 연타 → 무시(체인 경합 방지)
    couponBusy = true;       // 이하 모든 분기가 navigate/reload로 끝나므로 리셋 불필요
    pointReloading = true;
    var returnTo = window.location.pathname;
    function clearThen(keep) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).then(function() {
        if (keep && keep.length) {
          window.location.href = buildSequentialDiscountUrl(keep, returnTo);
        } else {
          window.location.reload();
        }
      }).catch(function() { window.location.reload(); });
    }
    pointFetchCart().then(function(cart) {
      var keep = pointGatherAppliedCodes(cart).filter(function(c) { return !pointIsPointCode(c); });
      clearThen(keep);
    }).catch(function() { clearThen(null); });
  }

  // 포인트가 적용돼 있으면 "포인트 사용 취소" 버튼을 폼 영역에 주입(중복 방지).
  function pointMaybeRenderRemove(cart) {
    var hasPoint = pointGatherAppliedCodes(cart).some(pointIsPointCode);
    var wrap = root.querySelector('.az-vip-block--point-form');
    if (!wrap) return;
    var container = wrap.closest('.az-discount-item') || wrap.parentNode;
    if (!container) return;
    var existing = container.querySelector('[data-az-point-remove]');
    if (hasPoint && !existing) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'az-link-btn az-point-remove';
      btn.setAttribute('data-az-point-remove', '');
      btn.textContent = 'ポイントの利用を取り消す';
      container.appendChild(btn);
    } else if (!hasPoint && existing) {
      existing.remove();
    }
  }

  // 쿠폰 적용 시도 결과 안내 — 시도한 쿠폰이 실제로 적용 안 됐으면 문구 표시.
  // (카트에 남은 코드가 아니라 sessionStorage의 "시도 기록"으로 판단 → clear/누락에도 안전)
  function pointForget(key) { try { sessionStorage.removeItem(key); } catch (e) {} }

  function pointCheckCouponAttempt(cart) {
    var raw = null;
    try { raw = sessionStorage.getItem(POINT_COUPON_ATTEMPT_KEY); } catch (e) {}
    if (!raw) return;
    var attempt = null, ts = 0;
    try { var o = JSON.parse(raw); attempt = o && o.c; ts = (o && o.t) || 0; } catch (e) { attempt = raw; }
    if (!attempt) { pointForget(POINT_COUPON_ATTEMPT_KEY); return; }
    if (ts && (Date.now() - ts > 60000)) { pointForget(POINT_COUPON_ATTEMPT_KEY); return; }  // 오래된 기록 폐기(stale 방지)

    // 적용 여부는 3소스를 모두 확인(표시 로직 cart-coupon.liquid와 동일 기준).
    // 제품 할인(amount off products)은 discount_codes가 아니라 아이템의
    // line_level_discount_allocations에만 잡히므로 discount_codes만 보면 오탐(경고 오출력)이 남.
    var applied = pointCouponIsApplied(cart, attempt);
    if (applied) { pointForget(POINT_COUPON_ATTEMPT_KEY); return; }  // 정상 적용됨 → 안내 불필요

    var couponErr = document.querySelector('[data-az-coupon-error]');
    if (!couponErr) return;  // 안내 요소 없음 → 키 남겨두고 다음 카트 방문에서 재시도(60s 만료로 보호)
    if (!couponErr.hidden) { pointForget(POINT_COUPON_ATTEMPT_KEY); return; }  // 더 구체적인 안내(knocked 등)가 이미 표시중 → 양보

    // 원인을 단정하지 않음 — 결합 불가/조건미달/만료/오타 모두 가능.
    couponErr.textContent = 'クーポン「' + attempt + '」を適用できませんでした。他の割引（ポイント等）との併用可否や、ご利用条件・有効期限をご確認ください。';
    couponErr.hidden = false;
    pointForget(POINT_COUPON_ATTEMPT_KEY);  // 표시 완료 후 제거
  }

  // 포인트 취소 버튼 클릭 (쿠폰 리스너와 별개)
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-az-point-remove]')) {
      e.preventDefault();
      removePointDiscount();
    }
  });

  // baseline 캡처 (현재 서버 카트 = SSR 반영값). 이후 변동분만 감지 대상.
  // + 포인트 적용 상태면 취소 버튼 주입. 실패 시 재시도(baseline null이면 감지 비활성).
  function pointCaptureBaseline(attempt) {
    pointFetchCart().then(function(cart) {
      pointBaselineSig = pointCartSig(cart);
      // 로드 시점의 포인트 코드를 "기존"으로 기록 → 이후 새로 실패한 코드만 안내
      (cart.discount_codes || []).forEach(function(d) {
        if (d && d.code && pointIsPointCode(d.code)) pointSeenPointCodes[d.code.toLowerCase()] = true;
      });
      // 로드 시점에 적용 중이던 쿠폰(비포인트) 기록 → 포인트가 이를 밀어냈는지 감지
      pointBaselineCoupons = pointGatherAppliedCodes(cart).filter(function(c) { return !pointIsPointCode(c); });
      pointMaybeRenderRemove(cart);
      pointCheckKnockedCoupon();       // 더 구체적인 안내 우선
      pointCheckCouponAttempt(cart);   // 이미 안내가 떠 있으면 양보(아래 가드)
    }).catch(function() {
      if ((attempt || 0) < 3) {
        setTimeout(function() { pointCaptureBaseline((attempt || 0) + 1); }, 1000);
      }
    });
  }
  pointCaptureBaseline(0);

  // 트리거 A: fetch 인터셉트 (원본 호출/반환 그대로 통과, 관찰만)
  // ⚠️ cart-notification.js도 window.fetch를 래핑함(공존). 두 래퍼 모두
  //    "원본 promise를 변형 없이 반환 + 관찰만(응답 body 미접근)" 규약을 지켜야 충돌이 없다.
  if (typeof window.fetch === 'function') {
    var pointOrigFetch = window.fetch;
    window.fetch = function(input) {
      var p = pointOrigFetch.apply(window, arguments);
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (pointIsMutatingUrl(url)) {
          p.then(function() { pointStartPoll(); }, function() {});
        }
      } catch (e) {}
      return p;
    };
  }

  // 트리거 A': XHR 인터셉트 (VIP/jQuery가 XHR을 쓸 경우 대비)
  (function() {
    var XHR = window.XMLHttpRequest;
    if (!XHR || !XHR.prototype) return;
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;
    XHR.prototype.open = function(method, url) {
      this.__azPointUrl = url;
      return origOpen.apply(this, arguments);
    };
    XHR.prototype.send = function() {
      try {
        if (pointIsMutatingUrl(this.__azPointUrl)) {
          this.addEventListener('loadend', function() { pointStartPoll(); }, { once: true });
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  })();

  // 트리거 B: 포인트 폼 상호작용 (capture phase → shadow DOM 경계 통과)
  function onPointFormInteraction(e) {
    if (pointReloading) return;
    var t = e.target;
    if (t && t.closest && t.closest('.az-vip-block--point-form')) pointStartPoll();
  }
  root.addEventListener('click', onPointFormInteraction, true);
  root.addEventListener('change', onPointFormInteraction, true);  // 입력 변경(blur 적용형) 대비
  root.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') onPointFormInteraction(e);
  }, true);

  // ============================================================
  // 결제 진행 — 미체크 상품은 카트에서 제거 후 /checkout
  // ============================================================

  if (stickyForm) {
    stickyForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var selected = getCurrentSelected();
      if (selected.length === 0) return;
      pointReloading = true;  // 곧 /checkout로 이동 → 포인트 동기화가 가로채지 않도록

      var allItems = [].slice.call(root.querySelectorAll('[data-az-item]'))
        .map(function(el) { return el.getAttribute('data-key'); });

      var toRemove = allItems.filter(function(k) { return selected.indexOf(k) === -1; });

      checkoutBtn.disabled = true;
      checkoutBtn.innerHTML = CHECKOUT_LOADING_HTML;

      if (toRemove.length === 0) {
        window.location.href = '/checkout';
        return;
      }

      var updates = {};
      toRemove.forEach(function(key) { updates[key] = 0; });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('update failed');
        return res.json();
      })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function(err) {
        log('checkout prep err', err);
        pointReloading = false;  // 결제 준비 실패(페이지 유지) → 포인트 동기화 재개
        alert('購入手続きの準備に失敗しました');
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = CHECKOUT_LABEL;
      });
    });
  }

  // ============================================================
  // 초기화: default 전체 선택
  // ============================================================

  function init() {
    if (selectAllInput) selectAllInput.checked = true;
    [].slice.call(root.querySelectorAll('[data-az-select-item]')).forEach(function(input) {
      input.checked = true;
    });
    refreshSummary();
  }

  init();
  log('initialized v1.4', { items: root.querySelectorAll('[data-az-item]').length });

})();